import { render, staticRenderFns } from "./UsersTabList.vue?vue&type=template&id=108cb82c&"
import script from "./UsersTabList.vue?vue&type=script&lang=js&"
export * from "./UsersTabList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports